import * as React from 'react';

import { NodeProps, Position } from '@xyflow/react';
import { Clock } from 'lucide-react';

import { BaseNode } from '../../BaseNode';
import type { FlowNode, NodeVisualDefinition } from '../../types';

import { DelayConfigType, getDelayPreviewText } from './schema';

/** Typed node for delay */
type DelayNodeType = FlowNode<DelayConfigType>;

/** Visual definition for the Delay node */
export const delayVisualDefinition: NodeVisualDefinition = {
  key: 'Delay',
  label: 'Delay',
  description: 'Pause the flow for a specified duration',
  icon: Clock,
  color: 'purple',
  handles: [
    {
      type: 'target',
      position: Position.Top,
      className: 'bg-gray!',
    },
    {
      type: 'source',
      position: Position.Bottom,
      className: 'bg-gray!',
    },
  ],
  getContent: getDelayPreviewText as (
    config: Record<string, unknown>,
  ) => string,
};

/**
 * Visual component for Delay nodes on the canvas.
 */
export const DelayNode = React.memo<NodeProps<DelayNodeType>>((props) => (
  <BaseNode
    {...props}
    definition={delayVisualDefinition}
    className="@DelayNode"
  />
));

DelayNode.displayName = 'DelayNode';
